import { appConfig } from '@/config';

export async function accountDetailsRequest(token, action = 'get', values = {}) {
  const response = await fetch(new URL('/business-api/account-details.php', appConfig.serviceOrigin), {
    method: 'POST', credentials: 'omit', cache: 'no-store',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, action, ...values })
  });
  let data;
  try {
    data = await response.json();
  } catch {
    const error = new Error('Invalid JSON response');
    error.code = 'invalid_json';
    error.status = response.status;
    throw error;
  }
  if (!response.ok || !data.ok) {
    const error = new Error(data.message || 'Account details request failed');
    error.code = data.error_code || 'account_details_unavailable';
    error.status = response.status;
    throw error;
  }
  return data;
}
